import React from 'react';
import { PrivacyPolicyPanel } from '../components/workspace/PrivacyPolicyPanel';
import { ArrowLeft } from 'lucide-react';
import { WorkiumLogo } from '../components/brand/WorkiumLogo';
export function PrivacyPage() {
  return <div className="min-h-screen bg-slate-950" data-id="element-7219">
      {/* Minimal public header */}
      <header className="sticky top-0 z-50 bg-slate-950/80 backdrop-blur-lg border-b border-slate-800" data-id="element-7220">
        <div className="max-w-4xl mx-auto px-4 lg:px-8 h-16 flex items-center justify-between" data-id="element-7221">
          <div className="flex items-center gap-6" data-id="element-7222">
            <a href="/" className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-900 border border-slate-800 text-slate-400 hover:text-slate-200 hover:bg-slate-800 transition-all" title="Volver al inicio" data-id="element-7223">
              <ArrowLeft size={16} data-id="element-7224" />
            </a>
            <WorkiumLogo size="sm" data-id="element-7225" />
          </div>
          <a href="/terms" className="text-sm text-indigo-400 hover:text-indigo-300 transition-colors" data-id="element-7226">
            Términos y Condiciones
          </a>
        </div>
      </header>
      <PrivacyPolicyPanel data-id="element-7227" />
    </div>;
}